import { Button } from './ui/button';

export default function FinancingBanner() {
	return (
		<section className="bg-gradient-to-r from-babyblue via-royalpurple to-orangepeel">
			<div className="container py-6 md:py-8 text-white flex flex-col md:flex-row items-center justify-between gap-4">
				<div>
					<div className="text-sm uppercase tracking-wide opacity-90">Drive Now, Pay Later</div>
					<h3 className="text-xl md:text-2xl font-bold">0% for 12 months with approved credit</h3>
					<p className="text-white/90">Financing options via Affirm and Klarna. Subject to approval. Terms apply.</p>
				</div>
				<div className="flex gap-3">
					<a href="/resources" className="hidden md:block"><Button variant="outline" className="border-white text-white hover:bg-white/10">Learn More</Button></a>
					<a href="https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5" target="_blank" rel="noreferrer"><Button className="bg-white text-secondary hover:opacity-90">Apply at Checkout</Button></a>
				</div>
			</div>
		</section>
	);
}
